import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  variant?: 'solid' | 'outline';
  className?: string;
};
export function CTAButton({
  label,
  variant = 'solid',
  className = ''
}: CTAButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 text-sm font-medium tracking-wide transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-void-950';
  const styles = variant === 'solid' ? 'bg-gold-500 text-void-950 shadow-neon-lg hover:bg-gold-400 hover:shadow-[0_0_60px_rgba(34,227,127,0.45)]' : 'border border-gold-500/50 text-gold-400 shadow-neon hover:border-gold-400 hover:bg-gold-500/10 hover:shadow-neon-lg';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} data-id="element-33" data-mp="3cnhqahh0v483">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="19a7v1s1mzo4o" />
    </a>;
}